<template>
  <div class="web-container">
    <!--页面顶部-->
    <div class="content-container page-header">
      <div class="flex flex-between">
        <div class="web-title flex flex-start">
          <img :src="webConfig.logoUrl" alt="" class="logo">
          <div class="title">
            <div class="title-school">{{webConfig.schoolName}}</div>
            <div class="title-name">{{webConfig.systemName}}</div>
          </div>
        </div>
        <!--导航列表-->
        <el-menu :default-active="navIndex" class="web-nav" mode="horizontal"
                 :active-text-color="'#4093f9'" @select="selectNav">
          <el-menu-item index="1">中心介绍</el-menu-item>
          <el-menu-item index="2">项目介绍</el-menu-item>
          <el-menu-item index="3">教学团队</el-menu-item>
          <el-menu-item index="4">友情链接</el-menu-item>
          <el-menu-item index="5" style="color: #4093f9">体验教学系统</el-menu-item>
        </el-menu>
      </div>
    </div>
    <!--轮播图-->
    <div class="focus-container ">
      <el-carousel :interval="6000" height="420px">
        <el-carousel-item v-for="item in webConfig.focusList" :key="item" style="text-align: center">
          <el-image
              style="width: 670px;height:420px;"
              :src="item"
              fit="fill"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!--中心介绍-->
    <a href="#" name="center"></a>
    <div class="li-container content-container">
      <el-divider content-position="center" class="content-title">中心介绍</el-divider>
      <div class="content-html html-view">
        <p>
          雅安职业技术学院马克思主义学院思政课虚拟仿真体验教学中心依托互联网信息技术，通过整合学校自身师资和教学资源，将虚拟仿真技术引入思想政治教育教学改革工作。中心通过“沉浸式”“体验式”教学方式，充分调动学生的学习积极性、主动性，推动学校思想政治课教学方式与现代信息技术有机融合。中心构建情景模拟虚拟空间，使学生在直观、生动、形象、逼真的三维场景中，通过虚拟仿真技术和交互操作“亲身体验”历史，并对历史现象和事件进行独立自主地分析、判断，从而实现思政育人春风化雨，润物无声的教学效果。</p>
        <p>
          中心秉持开放、共享原则，力争打造地方思想政治理论课实践教学基地特色品牌，提高我院思想政治教育的实效性、吸引力和影响力，服务我校思想政治理论课实践教学、思想政治教育工作以及地方社会发展需要。
        </p>
      </div>
    </div>
    <!--项目介绍-->
    <a href="#" name="experiment"></a>
    <div class="content-container experiment-container">
      <el-divider content-position="center" class="content-title">项目介绍</el-divider>
      <div class="experiment-list">
        <div class="sub-list flex flex-start flex-wrap">
          <div class="sub-li" v-for="(experimentItem,experimentIndex) in experiments.list">
            <img :src="experimentItem.product_iconLeft" alt="" class="left-icon"
                 v-if="experimentItem.product_iconLeft">
            <div class="bg">
              <img :src="experimentItem.product_bg+'?imageView2/1/w/290/h/183/q/75'">
            </div>
            <div class="info">
              <img class="avatar" :src="experimentItem.product_icon" alt="">
              <div class="flex flex-dr flex-center">
                <div class="title">{{ experimentItem.name }}</div>
                <div class="des-main word-hr ellipsis">{{ experimentItem.subName }}</div>
                <!--最多3行 每行18字 第三行超出省略号显示-->
                <div class="des word-hr ellipsis" v-html="experimentItem.description"></div>
                <div class="buttons">
                  <a class="button" href="javascript:void(0)"
                     @click="ExperimentMethods().clickViewExperiment(experimentItem)">查看详情</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--产品介绍弹窗-->
    <div v-if="experimentInfo.dialog" class="my-dialog-container flex flex-dr flex-center experiment-dialog">
      <div class="mask" @click="ExperimentMethods().closeExperimentDialog()"></div>
      <div class="dialog-box">
        <div class="bg"></div>
        <img src="@/assets/icon/dialog_close.png" alt="关闭" class="close-icon"
             @click="ExperimentMethods().closeExperimentDialog()">
        <div class="info-box">
          <div class="header-box flex flex-start">
            <img :src="experimentInfo.experiment.product_icon" class="avatar" alt="">
            <div class="name-box">
              <div class="name">{{ experimentInfo.experiment.name }}</div>
              <div class="series">{{ experimentInfo.experiment.seriesName }}</div>
            </div>
            <div>

            </div>
          </div>
          <div class="description-box">
            <div class="title">实验简介：</div>
            <div class="content">
              <p v-for="p in experimentInfo.experiment.experimentDescription.split('\n')">{{ p }}</p>
            </div>
          </div>
          <div class="view-box flex flex-between">
            <div class="video-box" v-if="experimentInfo.experiment.product_video">
              <video id="v1" loop="" preload="" muted="" x-webkit-airplay="true" airplay="allow"
                     webkit-playsinline="true" playsinline="true" :src="experimentInfo.experiment.product_video"
                     class="video1 video"
                     draggable="true"></video>
              <img src="@/assets/product/dialog/play.png" alt="" class="play-btn"
                   @click="e=>ExperimentMethods().playVideo(e)">
            </div>
            <el-image v-if="!experimentInfo.experiment.product_video" class="video-box-no" fit="cover"
                      :src="experimentInfo.experiment.product_info_img"
                      :preview-src-list="experimentDialogPicList"></el-image>
            <div class="img-box flex flex-around flex-wrap">
              <el-image
                  class="img"
                  fit="cover"
                  :src="experimentInfo.experiment.product_info_img_1"
                  :preview-src-list="experimentDialogPicList">
              </el-image>
              <el-image
                  class="img"
                  fit="cover"
                  :src="experimentInfo.experiment.product_info_img_2"
                  :preview-src-list="experimentDialogPicList">
              </el-image>
              <el-image
                  class="img"
                  fit="cover"
                  :src="experimentInfo.experiment.product_info_img_3"
                  :preview-src-list="experimentDialogPicList">
              </el-image>
              <el-image
                  class="img"
                  fit="cover"
                  :src="experimentInfo.experiment.product_info_img_4"
                  :preview-src-list="experimentDialogPicList">
              </el-image>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--团队介绍-->
    <a href="#" name="member"></a>
    <div class="member-container content-container">
      <el-divider content-position="center" class="content-title">教学团队</el-divider>
      <div class="member-list">
        <el-card class="box-card" style="margin-bottom: 20px" shadow="hover">
          <div slot="header" class="flex flex-center">
            <span>思德法教研室</span>
          </div>
          <div class="avatar-list flex flex-start flex-wrap">
            <div class="avatar-li" v-for="(item,index) in memberList[0]['list']" @click="clickMember(item,index)">
              <el-image
                  style="width: 200px; height: 200px"
                  :src="item.avatar"
                  fit="scale-down"></el-image>
              <div class="name">{{ item.name }}（{{ item.duty }}）</div>
            </div>
          </div>
        </el-card>
        <el-card class="box-card" shadow="hover">
          <div slot="header" class="flex flex-center">
            <span>概论教研室</span>
          </div>
          <div class="avatar-list flex flex-start flex-wrap">
            <div class="avatar-li" v-for="(item,index) in memberList[1]['list']" @click="clickMember(item,index)">
              <el-image
                  style="width: 200px; height: 200px"
                  :src="item.avatar"
                  fit="scale-down"></el-image>
              <div class="name">{{ item.name }}（{{ item.duty }}）</div>
            </div>
          </div>
        </el-card>
        <el-tabs tab-position="left" v-if="false">
          <el-tab-pane label="">
            <div class="avatar-list flex flex-start flex-wrap">
              <div class="avatar-li" v-for="(item,index) in memberList[0]['list']" @click="clickMember(item,index)">
                <el-image
                    style="width: 200px; height: 200px"
                    :src="item.avatar"
                    fit="scale-down"></el-image>
                <div class="name">{{ item.name }}（{{ item.duty }}）</div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="概论教研室">
            <div class="avatar-list flex flex-start flex-wrap">
              <div class="avatar-li" v-for="(item,index) in memberList[1]['list']" @click="clickMember(item,index)">
                <el-image
                    style="width: 200px; height: 200px"
                    :src="item.avatar"
                    fit="scale-down"></el-image>
                <div class="name">{{ item.name }}（{{ item.duty }}）</div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog
        :title="member.info.name"
        :visible.sync="member.dialog"
        :close-on-click-modal="true"
        width="900px"
        center
        v-el-drag-dialog>
      <div class="dialog-container">
        <el-descriptions direction="vertical" :column="4" border class="member-dialog">
          <el-descriptions-item label="现任职务">{{ member.info.duty }}</el-descriptions-item>
          <el-descriptions-item label="主授课程">{{ member.info.course }}</el-descriptions-item>
          <el-descriptions-item label="研究方向">{{ member.info.direction }}</el-descriptions-item>
          <el-descriptions-item label="主要社会兼职">{{ member.info.socialDuty }}</el-descriptions-item>
          <el-descriptions-item label="简历" :span="4">
            <div v-html="member.info.history" class="word-hr history"></div>
          </el-descriptions-item>
          <el-descriptions-item label="承担课题/研究成果" :span="4">
            <div v-html="member.info.success" class="word-hr success"></div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>
    <!--友情链接-->
    <a href="#" name="link"></a>
    <div class="link-container content-container">
      <el-divider content-position="center" class="content-title">友情链接</el-divider>
      <div class="list flex flex-around flex-wrap">
        <div v-for="item in linkConfig.list" v-if="item.img" @click="clickLink(item)">
          <el-image :src="item.img" alt="" class="li" fit="contain"></el-image>
          <div class="name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <!--底部-->
    <div class="page-footer">
      <div class="info-container content-container">
        <div class="infos">
          <img :src="webConfig.logoUrl" alt="" class="logo">
          <p>{{ webConfig.webName }}</p>
          <p>主办：{{ webConfig.colleageName }}</p>
          <span>技术支持：成都智云鸿道信息技术有限公司<i class="blank"></i></span>
          <span style="cursor: pointer" @click="window.open('https://beian.miit.gov.cn/')">
            &nbsp;&nbsp;&nbsp;&nbsp;{{
              webConfig.beiAnText
            }}</span>
        </div>
      </div>
    </div>

    <template>
      <el-backtop :bottom="50"></el-backtop>
    </template>
  </div>
</template>

<script>
import elDragDialog from "@/directive/el-drag-dialog";
import {H5_URL} from "@/model/ConfigModel";
import {isMobile} from "@/utils/common";
import {OfficialWebExperimentModel} from "@/model/erp/OfficialWebExperimentModel";

export default {
  name: "web_yazyjsxy",
  directives: {
    elDragDialog
  },
  data() {
    return {
      window: window,
      navIndex: "",
      webConfig: {
        "logoUrl": "http://resouce.cdzyhd.com/dae7be00-9478-44d9-8284-235441ae72a4.png",
        "indexBannerUrl": "http://116.63.187.43:7035/files/20220720/216212798869344256.jpeg",
        "schoolName": "雅安职业技术学院",
        "colleageName": "雅安职业技术学院马克思主义学院",
        "systemName":"思政课虚拟仿真体验教学中心",
        "focusList": [
            "http://resouce.cdzyhd.com/15f3e3d3-8d03-45be-876e-9dc7961ee2bd.jpg",
            "http://resouce.cdzyhd.com/a8915acf-4834-47ba-9679-5434a5b0804d.jpg",
        ],
        "webName": "雅安职业技术学院思政课虚拟仿真体验教学中心",
        beiAnText: "蜀ICP备19034784号-1"
      },
      introduceConfig: {
        "tabs": [{
          "name": "中心简介",
          "showNav": true,
          "text": "<p data-v-723f9522=\"\">&nbsp;</p>\n<p class=\"introduction-main-title\" style=\"margin: 0px; padding: 0px 0px 30px; font-family: 'PingFang SC'; font-size: medium; background-color: #f0f0f0;\" data-v-723f9522=\"\"><span class=\"name\" style=\"margin: 0px 0px 0px 100px; padding: 0px; display: block; float: left; height: 26px; font-size: 28px; font-family: PingFangSC; font-weight: bold; color: #333333; line-height: 21px; background: none;\" data-v-723f9522=\"\">概况介绍</span></p>\n<div class=\"introduction-main-box\" style=\"margin: 0px 0px 0px 100px; padding: 0px; width: 602px; font-family: 'PingFang SC'; font-size: medium; background-color: #f0f0f0;\" data-v-723f9522=\"\">\n<p style=\"margin: 0px 0px 0px 21.25pt; padding: 0px; font-size: 20px; font-family: PingFangSC; color: #666666; line-height: 40px; text-indent: 2em;\"><span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">雅安职业技术学院马克思主义学院思政课虚拟仿真实验教学中心成立于 2017年9月，在技术上接受学校现代教育技术中心指导，在实践教学管理上直属学院领导和学校教务处、经济管理实验教学中心督导。党的十八大以来，加强实践教学成为提升高校思政课教学思想性、理论性和亲和力、针对性的重要环节，学校党委高度重视思政课实践教学建设，2015年建设了&ldquo;红色文化走廊&rdquo;，把它作为开展校内红色教育的重要实践基地，并提出建设省级和国家级红色实践教学基地的发展目标。2019年6月，本中心获批四川省思政课VR虚拟仿真实践教学基地，为建设国家级基地创造了优良环境，提供了高质量建设的发展平台，确立了把思政课实践（实验）虚拟仿真实验教学中心建设成为融合三维建模，动画制作，动作捕捉，表情捕捉，人机交互，完全浸入式虚拟呈现等多种新技术于一体的教学、科研、创新平台的发展目标！</span></p>\n</div>\n<div>&nbsp;</div>",
          "id": "1661264029372"
        }, {
          "name": "教学团队",
          "showNav": true,
          "text": "<p class=\"introduction-main-title title-img clearfix\" style=\"margin: 0px; padding: 0px 0px 30px; font-family: 'PingFang SC'; font-size: medium; background-color: #f0f0f0;\" data-v-454ac076=\"\"><span class=\"number\" style=\"margin: 0px; padding: 0px; display: block; float: left; height: 28px; font-size: 36px; font-family: PingFangSC; font-weight: bold; color: #11397e; line-height: 21px; background: none;\" data-v-454ac076=\"\">01</span><span class=\"teamImg\" style=\"margin: 0px 0px 0px 100px; padding: 0px; float: left; width: 288px; background: none;\" data-v-454ac076=\"\"><img style=\"margin: 0px; padding: 0px; width: 288px; height: 402.148px;\" src=\"http://xicai.cdzyhd.com/upload/54dd64fa68e44da88e196f750cfdb9c3.png\" data-v-454ac076=\"\" data-src=\"upload/54dd64fa68e44da88e196f750cfdb9c3.png\" /></span></p>\n<p class=\"introduction-main-title\" style=\"margin: 0px; padding: 0px 0px 30px; font-family: 'PingFang SC'; font-size: medium; background-color: #f0f0f0;\" data-v-454ac076=\"\"><span class=\"name\" style=\"margin: 0px 0px 0px 100px; padding: 0px; display: block; float: left; height: 26px; font-size: 28px; font-family: PingFangSC; font-weight: bold; color: #333333; line-height: 21px; background: none;\" data-v-454ac076=\"\">唐晓勇</span><span class=\"school-titile\" style=\"margin: 0px; padding: 0px; font-size: 14px; background: none;\" data-v-454ac076=\"\">(</span><span class=\"school-titile\" style=\"margin: 0px; padding: 0px; font-size: 14px; background: none;\" data-v-454ac076=\"\">雅安职业技术学院</span>&nbsp;&nbsp;&nbsp;&nbsp;<span class=\"school-titile\" style=\"margin: 0px; padding: 0px; font-size: 14px; background: none;\" data-v-454ac076=\"\">教授/博士</span><span class=\"school-titile\" style=\"margin: 0px; padding: 0px; font-size: 14px; background: none;\" data-v-454ac076=\"\">)</span></p>\n<div class=\"introduction-main-box\" style=\"margin: 0px 0px 0px 100px; padding: 0px; width: 602px; font-family: 'PingFang SC'; font-size: medium; background-color: #f0f0f0;\" data-v-454ac076=\"\">\n<p style=\"margin: 0px; padding: 0px; font-size: 20px; font-family: PingFangSC; color: #666666; line-height: 40px; text-indent: 2em;\">1981.09<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">&mdash;&mdash;</span>1985.07&nbsp;<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">四川大学哲学系哲学专业（本科）；</span>&nbsp;</p>\n<p style=\"margin: 0px; padding: 0px; font-size: 20px; font-family: PingFangSC; color: #666666; line-height: 40px; text-indent: 2em;\">1985.09<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">&mdash;&mdash;</span>1988.07&nbsp;<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">四川大学哲学系外国哲学史专业（硕士研究生）；</span>&nbsp;</p>\n<p style=\"margin: 0px; padding: 0px; font-size: 20px; font-family: PingFangSC; color: #666666; line-height: 40px; text-indent: 2em;\">2006.09<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">&mdash;&mdash;</span>2012.07&nbsp;<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">雅安职业技术学院人口学专业（在职博士研究生）；</span>&nbsp;</p>\n<p style=\"margin: 0px; padding: 0px; font-size: 20px; font-family: PingFangSC; color: #666666; line-height: 40px; text-indent: 2em;\">1988.07<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">&mdash;&mdash;</span>2004.07<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">雅安职业技术学院马列教研部、政治系、两课教研中心（讲师、副教授）；</span></p>\n<p style=\"margin: 0px; padding: 0px; font-size: 20px; font-family: PingFangSC; color: #666666; line-height: 40px; text-indent: 2em;\">2004.07<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">&mdash;&mdash;</span>2008.06&nbsp;<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">雅安职业技术学院教务处副处长（教授）；</span>&nbsp;</p>\n<p style=\"margin: 0px; padding: 0px; font-size: 20px; font-family: PingFangSC; color: #666666; line-height: 40px; text-indent: 2em;\">2008.06<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">&mdash;&mdash;</span>2013.06&nbsp;<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">雅安职业技术学院人文（通识）学院院长（教授）；</span>&nbsp;</p>\n<p style=\"margin: 0px; padding: 0px; font-size: 20px; font-family: PingFangSC; color: #666666; line-height: 40px; text-indent: 2em;\">2013.06<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">&mdash;&mdash;<strong style=\"margin: 0px; padding: 0px;\">至今</strong></span>&nbsp;<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">雅安职业技术学院马克思主义学院院长（教授）。</span>&nbsp;</p>\n<p style=\"margin: 0px; padding: 0px; font-size: 20px; font-family: PingFangSC; color: #666666; line-height: 40px; text-indent: 2em;\"><span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\"><strong style=\"margin: 0px; padding: 0px;\">现任职务：</strong></span>&nbsp;<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">雅安职业技术学院马克思主义学院院长。</span>&nbsp;</p>\n<p style=\"margin: 0px; padding: 0px; font-size: 20px; font-family: PingFangSC; color: #666666; line-height: 40px; text-indent: 2em;\"><span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\"><strong style=\"margin: 0px; padding: 0px;\">主授课程：</strong></span>&nbsp;</p>\n<p style=\"margin: 0px; padding: 0px; font-size: 20px; font-family: PingFangSC; color: #666666; line-height: 40px; text-indent: 2em;\"><span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">马克思主义基本原理概论（本科）、西方哲学史（本科）、中西哲学比较研究（研究生）、马克思主义理论与方法（博士）、思想政治教育经典著作选读（博士）。</span>&nbsp;</p>\n<p style=\"margin: 0px; padding: 0px; font-size: 20px; font-family: PingFangSC; color: #666666; line-height: 40px; text-indent: 2em;\"><span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\"><strong style=\"margin: 0px; padding: 0px;\">研究方向：</strong></span>&nbsp;<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">马克思主义哲学、思想政治教育方法论</span>&nbsp;。</p>\n<p style=\"margin: 0px; padding: 0px; font-size: 20px; font-family: PingFangSC; color: #666666; line-height: 40px; text-indent: 2em;\"><span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\"><strong style=\"margin: 0px; padding: 0px;\">承担课题</strong></span><strong style=\"margin: 0px; padding: 0px;\">/</strong><span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\"><strong style=\"margin: 0px; padding: 0px;\">研究成果：</strong></span>&nbsp;</p>\n<p style=\"margin: 0px; padding: 0px; font-size: 20px; font-family: PingFangSC; color: #666666; line-height: 40px; text-indent: 2em;\">1.&nbsp;<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">国家社科课题《不完全信息博弈论的归纳概率逻辑基础》（</span>08BZX048<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">）；</span>&nbsp;</p>\n<p style=\"margin: 0px; padding: 0px; font-size: 20px; font-family: PingFangSC; color: #666666; line-height: 40px; text-indent: 2em;\">2.&nbsp;<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">四川省社科课题《深化文化产业管理，构建社会主义意识形态建设长效机制》（</span>SC13XS0012<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">）；</span>&nbsp;</p>\n<p style=\"margin: 0px; padding: 0px; font-size: 20px; font-family: PingFangSC; color: #666666; line-height: 40px; text-indent: 2em;\">3.&nbsp;<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">专著：哲学导论，雅安职业技术学院出版社，</span>1998<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">；</span>&nbsp;</p>\n<p style=\"margin: 0px; padding: 0px; font-size: 20px; font-family: PingFangSC; color: #666666; line-height: 40px; text-indent: 2em;\">4.&nbsp;<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">专著：当代中国哲学改革与发展，雅安职业技术学院出版社，</span>2004<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">；</span>&nbsp;</p>\n<p style=\"margin: 0px; padding: 0px; font-size: 20px; font-family: PingFangSC; color: #666666; line-height: 40px; text-indent: 2em;\">5.&nbsp;<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">论文：战后日本马克思主义哲学发展的特征，社会科学研究，</span>2001<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">（</span>6<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">）；</span>&nbsp;</p>\n<p style=\"margin: 0px; padding: 0px; font-size: 20px; font-family: PingFangSC; color: #666666; line-height: 40px; text-indent: 2em;\">6.&nbsp;<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">论文：马克思的生态观与中国共产党的科学发展观，马克思主义与现实，</span>2009<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">（</span>2<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">）；</span>&nbsp;</p>\n<p style=\"margin: 0px; padding: 0px; font-size: 20px; font-family: PingFangSC; color: #666666; line-height: 40px; text-indent: 2em;\">7.&nbsp;<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">论文：习近平依纪防腐思想的理论逻辑与实践路向，思想理论教育导刊，</span>2016<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">（</span>2<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">）。</span>&nbsp;</p>\n<p style=\"margin: 0px; padding: 0px; font-size: 20px; font-family: PingFangSC; color: #666666; line-height: 40px; text-indent: 2em;\"><span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\"><strong style=\"margin: 0px; padding: 0px;\">主要社会兼职：</strong></span>&nbsp;</p>\n<p style=\"margin: 0px; padding: 0px; font-size: 20px; font-family: PingFangSC; color: #666666; line-height: 40px; text-indent: 2em;\">1.&nbsp;<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">教育部高校思想政治理论课&ldquo;原理&rdquo;教学指导委员会委员；</span>&nbsp;</p>\n<p style=\"margin: 0px; padding: 0px; font-size: 20px; font-family: PingFangSC; color: #666666; line-height: 40px; text-indent: 2em;\">2.&nbsp;<span style=\"margin: 0px; padding: 0px; font-family: 宋体; background: none;\">四川省高校思想政治理论课&ldquo;原理&rdquo;专家指导组组长；</span>&nbsp;</p>\n<p style=\"margin: 0px; padding: 0px; font-size: 20px; fo... (10024 total length)",
          "id": "1661264039431"
        }], "name": "中心介绍"
      },
      experiments: {
        list: []
      },
      experimentInfo: {
        dialog: false,
        experiment: {},
        list: []
      },
      memberActive: "1",
      memberList: [
        {
          list: [
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/sdf/陈杰.JPG",
              name: "陈杰",
              duty: "教研室主任",
              course: "《思想道德与法治》",
              direction: "思想政治教育",
              success: "省级课题：智慧学习环境下高职思政课教师胜任力特征及提升路径研究（CJF22079）课题研究时限：202206-202406，课题负责人",
              socialDuty: "无",
              history: "2005.02--2007.06 河南教育学院 英语教育\n2008.09--2011.06 四川农业大学政法学院 思想政治教育（硕士研究生）\n2011.07--至今雅安职业技术学院马克思主义学院（教师）"
            },
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/sdf/郭英才.jpg",
              name: "郭英才",
              duty: "院长、书记",
              course: "《思想道德与法治》",
              direction: "思想政治教育",
              success: "",
              socialDuty: "无",
              history: "1994.09--1997.09  四川民族学院英语教育（专科）\n2002.09--2005.06 西华师范大学思想政治教育（硕士研究生）\n2005.06--至今 雅安职业技术学院马克思主义学院（教师）"
            },
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/sdf/任虹静.jpg",
              name: "任虹静",
              duty: "副院长",
              course: "《思想道德与法治》  《形势与政策》",
              direction: "思想政治教育",
              success: "省级课题：智慧学习环境下高职思政课教师胜任力特征及提升路径研究（CJF22079）课题研究时限：202206-202406，课题主研。",
              socialDuty: "无",
              history: "2008.09--2012.06 西华师范大学政治与行政学院思想政治教育(本科）\n" +
                  "2012.09--2014.06 西华师范大学政治与行政学院学科教学（思政）（硕士研究生）\n" +
                  "2014.07--至今 雅安职业技术学院马克思主义学院"
            },
            {
              avatar: "http://resouce.cdzyhd.com/966ea55d-fc14-4b29-a5c5-d4a6ea0122de.jpg",
              name: "唐娜娜",
              duty: "宣传部副部长",
              course: "《思想道德与法治》",
              direction: "思想政治教育",
              success: "《新发展格局下职业教育赋能四川革命老区乡村振兴的接续路径研究》-四川革命老区发展研究中心；2022，主研；\n《非传统安全视域下高校网络意识形态安全治理机制研究》-四川大学生思想政治教育研究中心；2022，主研；",
              socialDuty: "无",
              history: "2008.09--2010.06 潍坊学院市场营销（本科）\n2010.09--2013.06 西南科技大学马克思主义学院马克思主义基本原理（硕士研究生）\n2013.10--至今 雅安职业技术学院马克思主义学院（教师）"
            },
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/sdf/郭庆.jpg",
              name: "郭庆",
              duty: "院团委副书记",
              course: "《思想道德与法治》",
              direction: "思想政治教育",
              success: "1.主持省级思政青年专项课题《学生社团在思政课程中有机融入的研究与实践》\n" +
                  "2.主研团省委专项课题《高校团组织参与城市住宅校区团建创新路径研究》\n" +
                  "3.主持市级课题一项《雅安市贫困村留守人群现状分析》\n" +
                  "4.参研省级课题两项《雅安地方文化视域下的大学生思想政治教育调查研究》\n" +
                  "5.参与指导《我心中的思政课》视频录制获省上一等奖\n" +
                  "6.参与省级思政精品课程《毛泽东思想和中国特色社会主义思想》建设\n" +
                  "7.参加省级思政课程《思想道德修养与法律基础》建设",
              socialDuty: "无",
              history: "2011.09--2014.06 四川农业大学马克思主义学院（硕士研究生）\n2014.07--2020.10 雅安职业技术学院马克思主义学院（专职教师）\n2020.10——至今 雅安职业技术学院院团委（马院兼职教师）"
            },
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/sdf/熊俊霞.jpg",
              name: "熊俊霞",
              duty: "教师",
              course: "",
              direction: "思想政治教育",
              success: "",
              socialDuty: "无",
              history: "1983.09-1987.07 四川师范大学政教专业学习（本科）\n1987.07-2002.04 雅安教育学院（教师）\n2002.04——至今 雅安职业技术学院马克思主义学院（教师）"
            },
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/sdf/赵玉.jpg",
              name: "赵玉",
              duty: "教师",
              course: "《思想道德与法治》",
              direction: "思想政治教育",
              success: "",
              socialDuty: "无",
              history: "1997.09--2001.06 西华师范大学历史学教育（本科）\n2001.06--2007.01  南充市搬罾中学（教师）\n2007.01--至今 雅安职业技术学院马克思主义学院（教师）"
            },
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/sdf/罗春梅.png",
              name: "罗春梅",
              duty: "教师",
              course: "《思想道德与法治》",
              direction: "思想政治教育",
              success: "1.院级党建思政课题：佛系亚文化对大学生价值观的影响研究——以雅安职业技术学院为例；\n" +
                  "2.省级课题：智慧学习环境下高职思政课教师胜任力特征及提升路径研究（CJF22079）课题研究时限：202206-202406，课题主研人员",
              socialDuty: "无",
              history: "2010.09--2014.06 西华师范大学政治与行政学院思想政治教育（本科）\n2014.09--2017.06 西南大学马克思主义学院思想政治教育（硕士研究生）\n2017.08--至今 雅安职业技术学院马克思主义学院（教师）"
            },
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/sdf/李昭颖.jpg",
              name: "李昭颖",
              duty: "教师",
              course: "《思想道德与法治》《形势与政策》",
              direction: "思想政治教育",
              success: "",
              socialDuty: "无",
              history: "2014.09--2018.06 西华师范大学法学（本科）\n2018.09--2021.06 西华师范大学马克思主义法学（硕士研究生）\n2021.09--至今 雅安职业技术学院马克思主义学院（教师）"
            },

            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/sdf/肖钰菠.jpg",
              name: "肖钰菠",
              duty: "教师",
              course: "《思想道德与法治》",
              direction: "思想政治教育",
              success: "",
              socialDuty: "无",
              history: "2014.09--2018.06 四川农业大学理学院化学生物学\n2018.09--2021.06 四川农业大学马克思主义学院思想政治教育（硕士研究生）\n2021.09--至今 雅安职业技术学院马克思主义学院（教师）"
            },
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/sdf/赵葳仪.jpg",
              name: "赵葳仪",
              duty: "教师",
              course: "《思想道德与法治》",
              direction: "思想政治教育",
              success: "",
              socialDuty: "无",
              history: "2018.09-2021.06 四川农业大学马克思主义学院思想政治教育（硕士研究生）\n2021.08-至今 雅安职业技术学院马克思主义学院（教师）"
            },
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/sdf/杨少波.jpg",
              name: "杨少波",
              duty: "纪检干事",
              course: "《思想道德与法治》《大学生创新创业基础》《形势与政策》",
              direction: "思想政治教育、法律",
              success: "",
              socialDuty: "实习律师",
              history: "2011.09--2015.06 山东政法学院公共管理学院行政管理（本科）\n" +
                  "2016.09--2019.06 云南民族大学法学院法律（硕士研究生）\n" +
                  "2019.08--2021.12 中共雅安市委组织部高端人才服务中心（八级管理职员）\n" +
                  "2022.01--至今 雅安职业技术学院纪委办公室干事"
            },
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/sdf/黄君华.jpg",
              name: "黄君华",
              duty: "辅导员",
              course: "《思想道德与法治》",
              direction: "思想政治教育",
              success: "1.乡村振兴与精准扶贫战略协同推进研究（YA2019004）雅安市社科联2019.04-2019.10，课题负责人；\n" +
                  "2.雅安民族地区基层党组织创新研究（YA2018037）雅安市社科联2018.04-2018.10，课题负责人；\n" +
                  "3.新时代程度实施乡村振兴战略的政治伦理建构研究（2019A03）成都市社科联 2019.03-2020.06课题参与人（排名3/6）；\n" +
                  "4.家风传承与社会主义核心价值观教育研究雅安职业技术学院2017.10-2018.10课题负责人；\n" +
                  "5.脱贫攻坚与乡村振兴的政策衔接研究——以雅安市为例（YA2020036）雅安市社科联 2020.04-2020.10课题负责人\n" +
                  "6.现代学徒制背景下医学高专院校思政课实践育人模式研究——四川省思想政治教育研究（青年教师专项）课题 202201-2022.10课题负责人；\n" +
                  "7.乡村振兴战略背景下民族地区农村发展与治理研究——以雅安市为例（YAA20220020）202204-2022.10课题负责人；",
              socialDuty: "无",
              history: "2010.09——2014.06 四川农业大学政治学与行政学（本科）\n" +
                  "2014.09--2017.06 四川农业大学马克思主义基本原理（硕士）\n" +
                  "2017.09--至今 雅安职业技术学院（教师）"
            },
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/sdf/马春兰.jpg",
              name: "马春兰",
              duty: "辅导员",
              course: "《思想道德与法治》",
              direction: "思想政治教育",
              success: "2021年承担院级课题《雅安红色文化在高校思政课中的应用研究》",
              socialDuty: "无",
              history: "2007.09-2011.06 四川文理学院社会科学系历史学（本科）\n2015.09-2018.06 四川农业大学马克思主义学院马克思主义中国化研究专业（法学硕士）\n2020.09-至今 雅安职业技术学院药学与检验学院辅导员"
            },

          ]
        },
        {
          list: [
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/gl/雷厉.png",
              name: "雷厉",
              duty: "教研室主任",
              course: "《毛泽东思想和中国特色社会主义理论体系概论》《形势与政策》",
              direction: "思想政治教育",
              success: "主持、参与省市级校课题14项，结题14项。",
              socialDuty: "无",
              history: "1986.09—1990.05 四川师范学院历史专业学习；\n1990.07-2000.02  雅安财贸学校教师；\n2002.04-2014.04 雅安职业技术学院教师；"
            },
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/gl/李霓.jpg",
              name: "李霓",
              duty: "教师",
              course: "《毛泽东思想和中国特色社会主义理论体系概论》《形势与政策》《茶艺与茶道》",
              direction: "思想政治教育",
              success: "主持、参与省市级校课题10项，结题10项。",
              socialDuty: "无",
              history: "1982.07至1986.07 四川师范大学政教系学习；\n" +
                  "1986.07至2002.04 雅安教育学院教师\n" +
                  "2002.04至今 雅安职业技术学院马克思主义学院教师"
            },
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/gl/王坤容.JPG",
              name: "王坤容",
              duty: "副院长",
              course: "《毛泽东思想和中国特色社会理论体系概论》《形势与政策》",
              direction: "思想政治教育",
              success: "1.2017年3月，《雅安地方文化在当地高校思想政治教育的应用研究》文章在《文化创新比较研究》杂志发表，排名第1\n" +
                  "2.2018年10月，《互联网背景下高职院校思政课信息化教学改革探究》文章在《教育教学论坛》杂志发表，排名第1\n" +
                  "3.2018年2月，《手机媒体在高职院校思政政治理论课教学的应用研究》文章在《教育界》杂志发表，排名第1\n" +
                  "4.2019年6月，《网络思想政治教育的本质特征》文章在《中学政治参考》杂志发表，排名第1\n" +
                  "5.2021年9月，《高职院校概论课专题式教学改革探究》文章在《文存阅刊》杂志发表，排名第1\n" +
                  "6.2020年6月，《精准扶贫视域下高职院校教育扶贫如何精准发力》文章在《学园》杂志发表，排名第1\n" +
                  "7.2020年1月，《中国共产党人的历史使命研究》文章在《职业教育与区域发展》杂志发表，排名第1",
              history: "2006.09--2010.06西华大学马克思主义学院思想政治教育专业（本科）\n2010.09--2012.07天津师范大学马克思主义学院学科教学（思政）（硕士研究生）\n2012.10-至今 雅安职业技术学院马克思主义学院",
              socialDuty: "无",
            },
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/gl/洪松林.jpg",
              name: "洪松林",
              duty: "校人事处副处长",
              course: "《毛泽东思想和中国特色社会理论体系概论》",
              direction: "思想政治教育",
              success: "",
              socialDuty: "无",
              history: "1993.07-2002.04 雅安卫校教师；\n" +
                  "2002.04-2014.04 雅安职业技术学院教师；\n" +
                  "2014.04-2017.10 雅安职业技术学院思政部副主任；\n" +
                  "2017.10至今 雅安职业技术学院人事处副处长。"
            },
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/gl/吕登蓉.jpg",
              name: "吕登蓉",
              duty: "教务处副处长",
              course: "《毛泽东思想和中国特色社会主义理论体系概论》《形势与政策》《马克思主义基本原理》《中国近代史纲要》",
              direction: "思想政治教育",
              success: "主持省级课题2项，参与省级及以上课题7项。1项在研，其余已结题。",
              socialDuty: "无",
              history: "2002.09-2006.07 山西师范大学经济管理学院经济学本科；\n" +
                  "2007.09-2010.07 山西师范大学政法学院思想政治教育硕士研究生；\n" +
                  "2011.07-至今 雅安职业技术学院思政教师"
            },
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/gl/何衡.jpg",
              name: "何衡",
              duty: "教师",
              course: "《毛泽东思想和中国特色社会主义理论体系概论》《形势与政策》",
              direction: "思想政治教育",
              success: "主持省厅课题立项7项，结题5项；\n主持院级课题2项，结题1项;\n主研省厅课题3项，结题3项；\n主研院级1项，结题1项。",
              socialDuty: "无",
              history: "1999.9-2003.06 西华师范大学思想政治教育（本科）；\n2003.07-2008.08 重庆天府中学高中政治教师；\n2008.09-2011.06 重庆医科大学思想政治教育（硕士）；\n2011.07至今 雅安职业技术学院（教师）"
            },

            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/gl/王丹.jpg",
              name: "王丹",
              duty: "教师",
              course: "«毛泽东思想和中国特色社会主义理论体系概论»«形势与政策»",
              direction: "思想政治教育",
              success: "",
              socialDuty: "无",
              history: "1998.09-2002.6 四川师范学院历史教育专业（本科）；\n2003.09-2006.06 西华师范大学专门史专业（硕士）；\n2006.06至今 雅安职业技术学院（专任教师）"
            },
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/gl/张丹.jpg",
              name: "张丹",
              duty: "教师",
              course: "《毛泽东思想和中国特色社会主义理论体系概论》",
              direction: "思想政治教育",
              success: "主持、参与省市级课题7项，校级1项，结题7项，在研1项。",
              socialDuty: "无",
              history: "2005.09-2009.06 楚雄师范学院思想政治教育（本科）；\n2010.09-2013.06 四川农业大学马克思主义中国化研究（硕士研究生）；\n2013.07-至今 雅安职业技术学院（教师）"
            },
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/gl/常恒.jpg",
              name: "常恒",
              duty: "教师",
              course: "«毛泽东思想和中国特色社会主义理论体系概论»«形势与政策»",
              direction: "思想政治教育",
              success: "",
              socialDuty: "无",
              history: "2009.9-2013.6 西南民族大学市场营销（本科）；\n2013.6-2016.6 西南民族大学思想政治教育（硕士研究生）；\n2018.10-2020.10 四川科技职业技术学院（教师）；\n2020.10至今 雅安职业技术学院（教师）\n"
            },
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/gl/董晴晴.jpg",
              name: "董晴晴",
              duty: "教师",
              course: "",
              direction: "思想政治教育",
              success: "",
              socialDuty: "无",
              history: ""
            },
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/gl/张子君.jpg",
              name: "张子君",
              duty: "教师",
              course: "《毛泽东思想和中国特色社会主义理论体系概论》《社会工作概论》《形势与政策》",
              direction: "马克思主义中国化理论成果",
              success: "",
              socialDuty: "无",
              history: "2013.09-2017.06 滨州学院 思想政治教育（本科）\n" +
                  "2017.09-2020.06 兰州理工大学 马克思主义中国化研究（硕士研究生）\n" +
                  "2020.08—至今 雅安职业技术学院 （教师）"
            },

            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/gl/马梦思.png",
              name: "马梦思",
              duty: "教师",
              course: "《毛泽东思想和中国特色社会主义理论体系概论》《形势与政策》",
              direction: "思想政治教育",
              success: "",
              socialDuty: "无",
              history: "2013.09—2017.06 西华师范大学思想政治教育（本科）；\n" +
                  "2017.09—2020.06 西华师范大学思想政治教育（硕士研究生）；\n" +
                  "2020.08—至今 雅安职业技术学院（教师）"
            },
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/gl/李月夏.jpg",
              name: "李月夏",
              duty: "教师",
              course: "《毛泽东思想和中国特色社会主义理论体系概论》",
              direction: "思想政治教育",
              success: "",
              socialDuty: "无",
              history: "2015.09—2019.06 西华师范大学思想政治教育（本科）；\n" +
                  "2019.09—2021.06 西华师范大学学科教学（思政）（硕士研究生）；\n" +
                  "2021.08—至今 雅安职业技术学院（教师）"
            },
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/gl/苟雪.png",
              name: "苟雪",
              duty: "教师",
              course: "《毛泽东思想和中国特色社会主义理论体系概论》《党史》《形策》《习近平新时代中国特色社会主义理论读本（高中）》",
              direction: "思想政治教育",
              success: "",
              socialDuty: "无",
              history: "2014.09-2108.06 内江师范学院思想政治教育（本科）\n" +
                  "2018.09-2021.06 四川农业大学思想政治教育（硕士）\n" +
                  "2021.09--至今 雅安职业技术学院（教师）"
            },
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/gl/刘越.jpg",
              name: "刘越",
              duty: "教师",
              course: "",
              direction: "思想政治教育",
              success: "《毛泽东思想和中国特色社会主义理论体系概论》《形势与政策》",
              socialDuty: "无",
              history: "2013.09—2017.06 西南科技大学城市学院财务管理（本科）；\n" +
                  "2017.09—2020.06 西南科技大学思想政治教育（硕士）；\n" +
                  "2020.08—至今 雅安职业技术学院（教师）"
            },
            {
              avatar: "http://resouce.cdzyhd.com/exp_consumer/fe_dist/web/yazyjsxy/avatar/gl/钟琴.jpg",
              name: "钟琴",
              duty: "教师",
              course: "《毛泽东思想和中国特色社会主义理论体系概论》《党史》《中特》",
              direction: "思想政治教育",
              success: "",
              socialDuty: "无",
              history: "2014.09-2018.06 内江师范学院思想政治教育（本科）\n" +
                  "2018.09-2021.06 西南政法大学马克思主义理论（硕士）\n" +
                  "2021.09--至今 雅安职业技术学院（教师）"
            }
          ]
        },
      ],
      member: {
        dialog: false,
        info: {}
      },
      linkConfig: {
        list: [
          {
            "id": 1661270247796,
            "img": "http://resouce.cdzyhd.com/885bd161-02f4-4a24-829a-3f52f585c3dd.jpg",
            "name": "雅安职业技术学院马克思主义学院",
            "url": "https://szb.yazjy.com/"
          },
          {
            "id": 1662270247796,
            "img": "http://resouce.cdzyhd.com/d23cf15e-2e72-4e9f-8777-b23f55fb824c.png",
            "name": "成都智云鸿道",
            "url": "http://www.cdzyhd.com/"
          }
        ]
      },
    }
  },
  created() {
    if (isMobile()) {
      window.location.href = H5_URL + this.$route.path
    }
  },
  mounted() {
    document.title = "雅安职业技术学院思政课虚拟仿真体验教学中心"
    // 判断是不是在移动端
    this.getExperimentConfig()
  },
  methods: {
    // 获取产品配置
    async getExperimentConfig() {
      // 要获取的实验列表，和自定义属性
      let experimentList = [
        {id: "1643014260081", name: "强渡大渡河"},
        {id: "1618476671539", name: "巧渡金沙江"},
        {id: "1618478479657", name: "中共一大"},
        {id: "1644387986690", name: "我和我的战疫"},
      ]
      let list = []
      for (let i = 0; i < experimentList.length; i++) {
        let id = experimentList[i]["id"]
        let experiment = await OfficialWebExperimentModel.getOneExperimentConfig(id)
        let experimentLast=Object.assign({},experiment,experimentList[i])
        // 合并自定义项
        list.push(experimentLast)
        this.$set(this.experiments, "list", list)
      }
    },
    // 点击首页导航
    selectNav(v) {
      switch (v) {
        case "1":
          window.location.href = "#center"
          break;
        case "2":
          window.location.href = "#experiment"
          break;
        case "3":
          window.location.href = "#member"
          break;
        case "4":
          window.location.href = "#link"
          break;
        case "5":
          window.location.href = "/login?schoolId=102055742013444096"
          break;
      }
    },
    // 点击团队成员
    clickMember(item, index) {
      this.$set(this.member, "info", item)
      this.member.dialog = true
    },
    // 点击友情链接
    clickLink(item) {
      window.open(item.url)
    },
    // 实验项目方法集
    ExperimentMethods() {
      let $this = this;
      return {
        clickViewExperiment(experiment) {
          $this.experimentInfo.dialog = true
          document.body.style.overflow = 'hidden'
          $this.experimentDialogEnterBtn = false
          $this.$set($this.experimentInfo, "experiment", experiment);
          $this.experimentDialogPicList = [
            experiment.product_info_img_1,
            experiment.product_info_img_2,
            experiment.product_info_img_3,
            experiment.product_info_img_4,
          ]
          if (!experiment.product_video && experiment.product_info_img) {
            $this.experimentDialogPicList.push(experiment.product_info_img)
          }
          setTimeout(() => {
            $(".experiment-dialog .bg").css("background-image", `url(${experiment.product_info_bg})`)
          }, 100)
        },
        // 关闭实验弹窗
        closeExperimentDialog() {
          $this.experimentInfo.dialog = false
          document.body.style.overflow = ''
        },
        // 播放视频
        playVideo(e) {
          // this.videoPlay = true
          // document.querySelector("#v1").play()
          $this.experimentInfo.experimentVideoDialog = true
        }
      }
    }
  }
}
</script>
<style>
.el-menu--horizontal {
  border-bottom: none !important;
}

.el-menu--horizontal > .el-menu-item {
  margin-right: 20px !important;
  font-size: 18px !important;
  color: #777;
  letter-spacing: 2px;
  font-weight: 500;
}

.el-menu--horizontal > .el-menu-item:hover {
  transition: all 0.2s linear;
  transform: scale(1.1);
}

.el-menu--horizontal > .el-submenu .el-submenu__title {
  font-size: 16px !important;
  letter-spacing: 2px;
}

.el-menu--horizontal .el-menu .el-menu-item {
  font-size: 14px !important;
  text-align: center;
}
</style>
<style scoped lang="less">
@import '../../style/app.less';

.web-container {
  //background-color: #f2f2f2;
}

.content-container {
  &:hover {
    .el-divider__text {
      color: #4093f9;
      font-size: 24px;
    }

  }
}

.content-title {
  margin-top: 40px;

  .el-divider__text {
    font-size: 22px;
    color: #777;
    font-weight: 450;
    text-align: center;
    margin-bottom: 20px;
  }

}

.page-header {
  width: 1280px;
  margin:0 auto;
  margin-bottom: 30px;
  padding:15px 0px;
  background-color: #fff;
  z-index: 1999;
  border-bottom: 1px solid #cecece;

  .web-title {


    .logo {
      width: 70px;
      height: 70px;
      margin-right: 10px;
      cursor: pointer;
    }

    div.title {
      font-size: 20px;
      color: #666;
      font-weight: bold;
      text-align: center;
      div.title-school{
        margin-bottom: 8px;
      }
      div.title-name{

      }
    }
  }
  .web-nav{

  }
}

.focus-container {

}

.li-container {
  margin-bottom: 50px;

  .content-html {
    margin-top: 45px;

    text-indent: 2em;
    font-size: 15px;
    color: #666;
    line-height: 25px;
    letter-spacing: 1px;
  }
}

.experiment-list {
  margin-top: 55px;

  .sub-list {
    .sub-li {
      margin-bottom: 20px;
      margin-right: 40px;
      position: relative;

      &:nth-child(4n+4) {
        margin-right: 0px;
      }

      &:hover {
        .bg {
          img {
            transition: all 0.5s linear;
            transform: scale(1.1);
          }
        }

        .info {
          box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);

          .avatar {
            margin-top: -30px;
            opacity: 0;
          }


          .des-main {
            opacity: 0;
          }

          .title {
            margin-top: -30px;
            margin-bottom: 0px;

          }

          .des {
            display: -webkit-box;
          }

          .buttons {

            display: block;
          }
        }

      }


      img.left-icon {
        position: absolute;
        width: 60px;
        height: 60px;
        top: -10px;
        left: -10px;
        z-index: 10;
      }

      .bg {
        z-index: 1;
        width: 290px;
        height: 183px;
        overflow: hidden;
        position: relative;

        img {
          width: 290px;
          height: 183px;
          display: block;
          transition: all 0.5s linear;
          transform: scale(1);

        }
      }

      .info {
        position: relative; // 解决margin-top负数 和同级div的z-index问题
        padding: 25px;
        height: 180px;
        z-index: 2;
        width: 270px;
        margin: 0 auto;
        margin-top: -60px;
        text-align: center;
        background: #fff;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        border-bottom: 3px solid transparent;
        transition: all 0.2s linear;
        overflow: hidden;

        .avatar {
          display: inline-block;
          width: 60px;
          height: 60px;
          position: relative;
          margin-top: 0px;
          transition: all 0.2s linear;
          border-radius: 4px;
          box-shadow: 2px 2px 5px 1px #dedede;
        }

        .title {
          position: relative;
          font-size: 16px;
          font-weight: bold;
          margin-top: 18px;
          margin-bottom: 10px;
          transition: all 0.2s linear;
        }

        .des-main {
          transition: all 0.2s linear;
          color: #666;
          font-size: 14px;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          display: -webkit-box;
        }

        .des {
          font-weight: 300;
          font-size: 14px;
          display: none;
          color: #666;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }

        .buttons {
          display: none;
          text-align: center;
          margin-top: 12px;
        }

        .button {
          width: 100px;
          line-height: 28px;
          border: 1px solid #d8d8d8;
          border-radius: 15px;
          text-align: center;
          font-size: 14px;
          color: #666666;
          position: relative;
          cursor: pointer;
          transition: all 0.2s linear;
          text-decoration: none;
          padding: 5px 20px;

          &:hover {
          }
        }

      }
    }
  }
}

.experiment-dialog {
  border-radius: 4px;
  z-index: 2000; // 解决被遮挡问题
  .dialog-box {
    border-radius: 4px;
  }

  .bg {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    width: 100%;
    height: 330px;
    background-size: cover;
    background-position: 50% 50%;
  }

  .close-icon {
    display: inline-block;
    width: 24px;
    height: 24px;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }

  .info-box {
    padding: 0px 80px;
  }

  .header-box {
    position: relative;
    margin-top: -115px;

    .avatar {
      width: 130px;
      height: 130px;
      border-radius: 4px;
      box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.2);
      margin-right: 20px;
    }

    .name-box {
      .name {
        font-size: 33px;
        font-weight: bold;
        line-height: 44px;
        color: #FFFFFF;
        text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
        opacity: 0.9;
      }

      .series {
        font-size: 16px;
        font-weight: 400;
        line-height: 21px;
        color: #FFFFFF;
        text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
        opacity: 0.9;
        margin-bottom: 8px;
      }
    }

    .enter-btn {
      margin-left: 300px;
      width: 97px;
      height: 29px;
      background-size: cover;
      background-position: 50% 50%;
      -webkit-backface-visibility: hidden;
      //background-image: url("../assets/product/dialog/enter-btn.png");
      cursor: pointer;
    }

    .view-now-btn {
      display: inline-block;
      padding: 10px 30px;
      background-color: #ff3829;
      color: #fff;
      font-size: 14px;
      margin-left: 200px;
      border-radius: 20px;
    }

  }

  .description-box {
    font-size: 16px;
    font-weight: 400;
    line-height: 21px;
    color: #333333;
    margin-top: 20px;

    .title {
      font-size: 16px;
      line-height: 21px;
      font-weight: 400;
      color: #333;
    }

    .content {
      margin-top: 5px;
      font-size: 14px;
      text-indent: 2em;
      font-weight: 400;
      line-height: 19px;
      color: #333333;
    }
  }

  .view-box {
    width: 100%;
    margin-top: 25px;
    margin-bottom: 35px;

    .video-box {
      width: 337px;
      height: 223px;
      position: relative;

      video {
        position: absolute;
        left: 0;
        top: 0;
        width: 337px;
        height: 223px;
        object-fit: fill;
        z-index: 1;
      }

      .play-btn {
        position: absolute;
        // 上下左右居中
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: 54px;
        height: 54px;
        cursor: pointer;
        z-index: 2;
      }
    }

    .video-box-no {
      width: 337px;
      height: 223px;
      background-size: cover;
      background-position: 50% 50%;
      -webkit-backface-visibility: hidden;
    }

    .img-box {
      width: 695px;

      .img {
        width: 334px;
        height: 106px;
        cursor: pointer;

        &:nth-child(1), &:nth-child(2) {
          margin-bottom: 11px;
        }
      }
    }
  }
}

.member-list {
  margin: 0 auto;
  margin-top: 50px;
  margin-bottom: 55px;
  width: 1240px;

  .el-card {
    border: none;
  }

  .avatar-list {
    .avatar-li {
      cursor: pointer;
      margin-top: 15px;
      margin-left: 34px;
      margin-right: 0px;

      .el-image {
        background-size: cover;
        background-position: 50% 50%;
        -webkit-backface-visibility: hidden;
        opacity: 1;
        transform: scale(1);
        cursor: pointer;


        &:hover {
          transition: all 0.3s linear;
          transform: scale(1.1);
        }
      }

      .name {
        text-align: center;
        margin-top: 15px;
        color: #888;
        font-size: 15px;
      }
    }
  }
}

.member-dialog {
  .history {
    text-align: left;
    font-size: 14px;
    color: #888;
  }

  .success {
    text-align: left;
    font-size: 14px;
    color: #888;
  }
}

// 友情链接
.link-container {
  margin-bottom: 45px;

  .list {
    margin-top: 40px;
    text-align: center;
    display: grid;
    justify-content: space-between;
    grid-template-columns: repeat(auto-fill, 285px);
    grid-gap: 10px;

    .name {
      margin-top: 10px;
      color: #777;
      font-size: 15px;
    }
  }


  .li {
    width: 285px;
    height: 140px;
    margin-top: 10px;
    //margin-right: 10px;
    background-size: cover;
    background-position: 50% 50%;
    -webkit-backface-visibility: hidden;
    opacity: 1;
    transform: scale(1);
    border-radius: 4px;
    cursor: pointer;
    box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.1);

    &:hover {
      transition: all 0.3s linear;
      transform: scale(1.03);
    }
  }

  .more {
    text-align: center;
    cursor: pointer;
    transition: all 0.3s linear;
    width: 100px;
    margin: 0 auto;
    margin-top: 30px;
    color: #707070;

    &:hover {
      transform: scale(1.1);
    }

    span {
      font-weight: 400;
      line-height: 21px;
      color: #707070;
      font-size: 16px;
      margin-right: 3px;
    }

    img {
      width: 22px;
      height: 22px;
      display: inline-block;
      margin-left: 4px;
    }
  }
}

.page-footer {
  background-color: #2d2d2d;
  padding: 20px 0px;

  .info-container {
    .logo {
      width: 70px;
      height: 70px;
      cursor: pointer;
      display: none;
    }

    .infos {
      text-align: center;
      color: @remark-color;
      font-size: 14px;

      span {
        margin-right: 10px;
      }
    }
  }
}

.back-top {
  position: fixed;
  bottom: 40px;
  right: 40px;
  z-index: 99999;

  img {
    width: 40px;
    height: 40px;
  }
}
</style>
